import { isArrayOf, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { isMediaFormatRawData, MediaFormatRawData } from "./MediaFormat.js";
import { isMediaMetaData, MediaMetaData } from "./MediaMetaData.js";
import { isThumbnailResource, ThumbnailResource } from "./MediaThumbnailResource.js";


export type MediaId = string;

export function isMediaId(obj: any): obj is MediaId {
    return isString(obj);
};


/**
 * informazioni grezze (provenienti da server) con le informazioni sul media
 */
export interface MediaInfoRawData<F extends MediaFormatRawData> {

    id: MediaId,
    title: string,
    description?: string,
    url: string,
    linkedResource?: string,
    thumbnail?: ThumbnailResource
    format: F[],
    socialInfo?: {
        share?: number,
        heart?: number,
        view?: number
    }
    meta?: MediaMetaData,
};

/**
 * barrier per oggetti di tipo VideoInfoRawData
 * @param obj l'oggetto da verificare
 * @returns 
 */
export function isMediaInfoRawData(obj: any): obj is MediaInfoRawData<any> {
    return isObject(obj) &&
        (hasOwnProperty(obj, 'id') && isString(obj['id'])) &&
        (hasOwnProperty(obj, 'title') && isString(obj['title'])) &&
        (!hasOwnProperty(obj, 'description') || isString(obj['description'])) &&
        (hasOwnProperty(obj, 'url') && isString(obj['url'])) &&
        (!hasOwnProperty(obj, 'thumbnail') || isThumbnailResource(obj['thumbnail'])) &&
        (hasOwnProperty(obj, 'format') && isArrayOf(obj['format'], isMediaFormatRawData)) &&
        (!hasOwnProperty(obj, 'meta') || isMediaMetaData(obj['meta']));
};